import { PREPARATION_STAGES, type PreparationStage } from '../types';

export const US_VISA_PORTAL_URL = 'https://ais.usvisa-info.com';

export type StageIntent = 'prepare' | 'schedule';

const INTENT_BY_STAGE: Record<PreparationStage, StageIntent> = {
  not_started: 'prepare',
  form_filed: 'prepare',
  fee_paid: 'prepare',
  portal_ready: 'schedule',
};

export function stageIntent(stage: PreparationStage): StageIntent {
  return INTENT_BY_STAGE[stage];
}

export function invitesConsulting(stage: PreparationStage): boolean {
  return stage === 'not_started';
}

const STAGES_WITH_OFFICIAL_TERM = new Set<PreparationStage>([
  'form_filed',
  'fee_paid',
  'portal_ready',
]);

export function hasOfficialTerm(stage: PreparationStage): boolean {
  return STAGES_WITH_OFFICIAL_TERM.has(stage);
}

export function stageRank(stage: PreparationStage): number {
  return PREPARATION_STAGES.indexOf(stage);
}
